<template>
  <div class="wrapper" style="padding-top: 50px">
    <b-form>
      <div class="log_in_text">
        <h3><b>ENTER TICKET ID</b></h3>
      </div>
      <div class="input-wrapper">
        <input
          v-model="bookingCode"
          v-on:keyup.enter="onSubmitBookingCode()"
          autofocus
          type="text"
          name="bookingCode"
          id="bookingCode"
          ref="bookingCode"
          class="app-input"
          placeholder="Ticket ID"
        />
      </div>
      <div class="manual_btn_in">
        <button
          @click.prevent.stop="onSubmitBookingCode()"
          class="btn-app-submit"
        >
          Proceed
        </button>
        <button @click.prevent.stop="goToHome()" class="btn-app-submit-new">
          Cancel
        </button>
      </div>
    </b-form>
  </div>
</template>

<script>
import BookingService from "@/services/BookingService";
export default {
  name: "hello",
  data() {
    return {
      bookingCode: ""
    };
  },
  mounted() {
    setTimeout(() => {
      if (this.$refs.bookingCode) {
        this.$refs.bookingCode.focus();
      }
    }, 400);
  },
  methods: {
    onSubmitBookingCode() {
      if (this.bookingCode) {
        this.$router.push({
          name: "details",
          query: { qrcode: this.bookingCode }
        });
      } else {
        this.$toasted.show("Please Enter Booking Code");
      }
    },
    goToScan() {
      this.$router.push({
        name: "qrCode",
        path: "/qrCode"
      });
    },
    goToHome() {
      this.$router.push({
        name: "Home",
        path: "/home"
      });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/ManualLogin.vue